import { FC, useEffect } from "react";
import styles from "./styles.module.scss";
import { useAppDispatch } from "hooks";
import { setPageTitle, setPageType } from "store";
import { PageType } from "types";

interface Props {
  pageTitle: string;
  pageType: PageType;
  src: string;
  blobUrl?: string;
}

const { BlobBaseUrl } = window.config;

export const Image: FC<Props> = ({
  pageTitle,
  pageType,
  src,
  blobUrl = BlobBaseUrl,
}) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setPageType(pageType));
    dispatch(setPageTitle(pageTitle));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      <img src={`${blobUrl}${src}`} alt={pageTitle} className={styles.image} />
    </div>
  );
};
